import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { Provider } from "react-redux";

import store from "./store";
import { TourProvider } from "@reactour/tour";

const steps = [
  {
    selector: '.step1',
    position: 'center',
    content: 'Olá, seja bem-vindo à nossa gestão de análiso!',
  },
  {
    selector: '.step2',
    content: 'Primeiramente queria lhe informar que sua ´complience´ está vazia, isso significa que você ainda não fez nenhuma análise.',
  },
  {
    selector: '.step3',
    position: 'center',
    content: 'Para começarmos, importe os arquivos necessários para ser a análise pendente.',
  },
]

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter>
        <TourProvider steps={steps}>
          <App />
        </TourProvider>
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);
